import { put, select } from 'redux-saga/effects';
import { selectedProductSelector } from 'ctm-selectors';

const setShowFrequencyToggle = function* (action) {
    const selectedProduct = yield select(selectedProductSelector);
    const price = selectedProduct.getIn(['productMeta', 'price']);
    const { monthlyAvailable, annualAvailable } = price.toJS();
    yield put({
        type: 'SET_RESULTS_CONFIG_VALUE',
        key: 'helpers.displayFrequencyToggle',
        value: monthlyAvailable && annualAvailable ? 'Y' : 'N'
    });
};

export default [
    'SET_SHOW_FREQUENCY_TOGGLE', setShowFrequencyToggle
];
